var Shaders = {
    'earth' : {
        uniforms: {
            'texture': { type: 't', value: 0, texture: null }
        },
        vertexShader: [
            'varying vec3 vNormal;',
            'varying vec2 vUv;',
            'void main() {',
                'vUv = uv;',
                'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );',
                'vNormal = normalize( normalMatrix * normal );',
            '}'
        ].join('\n'),
        fragmentShader: [
            'uniform sampler2D texture;',
            'varying vec3 vNormal;',
            'varying vec2 vUv;',
            'void main() {',
                'vec3 diffuse = texture2D( texture, vUv ).xyz;',
                'float intensity = 1.05 - dot( vNormal, vec3( 0.0, 0.0, 1.0 ) );',
                'vec3 atmosphere = vec3(0.55, 0.57, 0.36) * pow( intensity, 3.0 );',
                'gl_FragColor = vec4( diffuse - atmosphere, 1.0 );',
                // 'gl_FragColor = vec4(vUv,0.,1.);',
            '}'
        ].join('\n')
    },
    'atmosphere' : {
        uniforms: {},
        vertexShader: [
            'varying vec3 vNormal;',
            'void main() {',
                'vNormal = normalize( normalMatrix * normal );',
                'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );',
            '}'
        ].join('\n'),
        fragmentShader: [
            'varying vec3 vNormal;',
            'void main() {',
                'float intensity = pow( 0.8 - dot( vNormal, vec3( 0, 0, 1.0 ) ), 12.0 );',
                'gl_FragColor = vec4( 0.45, 0.43, 0.64, 0.6 ) * intensity;',
            '}'
        ].join('\n')
    }
};
// glColor4f(0.45, 0.43, 0.64, 1.00)
//RGBA(0.5, 0.1, 0.95, 1.00)